import React from 'react'

import { UserInfo } from '@/providers/auth-types'
import { Company } from '@/types/dashboard-types'

import AssetSeverityIcon from './AlertSeverityIcon'
import AssetNameCol from './AssetNameCol'
import GatewayIcon from './GatewayIcon'
import PowerStateIcon from './PowerStateIcon'

import { AssetStateSummary } from '../types'

interface AssetCompositeCellProps {
  asset: AssetStateSummary
  user: UserInfo | null
  company: Company | undefined
}

const AssetCompositeCell: React.FC<AssetCompositeCellProps> = ({ asset }) => {
  return (
    <div className="flex items-center w-full h-full">
      <div className="flex-1 min-w-0 truncate">
        <AssetNameCol name={asset.name} umd={asset.umd} isShared={!!asset.ccpShared} />
      </div>
      <div className="shrink-0 self-stretch pr-[5px] flex">
        <div className="w-[55px] flex items-center justify-start pl-[5px] border-l border-gray-300">
          <AssetSeverityIcon severity={asset.highestAlertSeverity} />
        </div>
        <div className="w-[55px] flex items-center justify-start pl-[5px] border-l border-gray-300">
          <PowerStateIcon
            powerState={asset.powerState}
            powerStateSampleTime={asset.powerStateSampleTime}
            maintenanceModeEventSampleTime={asset.maintenanceModeEventSampleTime}
            maintenanceMode={asset.maintenanceMode}
          />
        </div>
        <div className="w-[55px] flex items-center justify-start pl-[5px] border-l border-gray-300">
          <GatewayIcon
            gatewayOn={asset.gatewayOn}
            addressShort={asset.addressShort}
            geofence={asset.geofence}
            umdBatteryVoltage={asset.umdBatteryVoltage}
            umdSampleTime={asset.umdSampleTime}
            umdSleepMode={asset.umdSleepMode}
          />
        </div>
      </div>
    </div>
  )
}

export default AssetCompositeCell
